import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { dateToString } from '../validators/date.validator';

@Injectable({
  providedIn: 'root',
})
export class SAFormValidator {
  ndisNumberExists?: boolean;
  dob: any;
  constructor(private http: HttpClient, private router: Router) {}

  removeError(control: AbstractControl, error: string) {
    const err = control.errors; // get control errors
    if (err) {
      delete err[error]; // delete your own error
      if (!Object.keys(err).length) {
        // if no errors left
        control.setErrors(null); // set control errors to null making it VALID
      } else {
        control.setErrors(err); // controls got other errors so set them back
      }
    }
  }

  SAFValidator(form: AbstractControl) {
    const ndisNumberControl = form.get('ndisNumber');
    this.removeError(ndisNumberControl!, 'noMatch');
    const firstNameControl = form.get('participantFirstName');
    this.removeError(firstNameControl!, 'noMatch');
    const lastNameControl = form.get('participantLastName');
    this.removeError(lastNameControl!, 'noMatch');
    const dobControl = form.get('participantDOB');
    this.removeError(dobControl!, 'noMatch');

    const ndisNumber = ndisNumberControl!.value;
    const firstName = firstNameControl!.value;
    const lastName = lastNameControl!.value;
    const dob = dateToString(dobControl!.value);

    if (ndisNumber && firstName && lastName && dob) {
      const headers = { 'Content-Type': 'application/json' };

      const inputData = {
        ndisNumber,
        firstName,
        lastName,
        dob,
      };
      const data = JSON.stringify(inputData);

    }
  }
}
